<script setup>
const props = defineProps({
    route: {
        type: Object,
        required: true
    },
    collapsed: {
        type: Boolean,
        default: false
    },
    depth: {
        type: Number,
        default: 0
    }
});

const emit = defineEmits(['menu-click']);

const hasChildren = (route) => {
    return route.children && route.children.length > 0;
};

// 處理點擊事件
const handleClick = (route) => {
    emit('menu-click', route);
};
</script>

<template>
    <template v-if="hasChildren(route)">
        <a-sub-menu :key="`sub-${route.name}`">
            <template #title>
                <div class="menu-item-content">
                    <component
                        v-if="route.meta?.icon && depth === 0"
                        :is="route.meta.icon"
                    />
                    <span v-if="!collapsed" class="menu-title-clip">
                        <span class="menu-title-marquee">
                            <span class="menu-title-label">
                                {{ route.meta.title }}
                            </span>
                            <span class="menu-title-ghost" aria-hidden="true">
                                {{ route.meta.title }}
                            </span>
                        </span>
                    </span>
                </div>
            </template>
            <recursive-menu-item
                v-for="child in route.children"
                :key="child.name"
                :route="child"
                :collapsed="collapsed"
                :depth="depth + 1"
                @menu-click="emit('menu-click', $event)"
            />
        </a-sub-menu>
    </template>
    <a-menu-item v-else :key="`item-${route.name}`" @click="handleClick(route)">
        <div class="menu-item-content">
            <component
                v-if="route.meta?.icon && depth === 0"
                :is="route.meta.icon"
            />
            <span v-if="!collapsed" class="menu-title-clip">
                <span class="menu-title-marquee">
                    <span class="menu-title-label">{{ route.meta.title }}</span>
                    <span class="menu-title-ghost" aria-hidden="true">
                        {{ route.meta.title }}
                    </span>
                </span>
            </span>
        </div>
    </a-menu-item>
</template>

<style scoped>
.menu-item-content {
    @apply flex items-center gap-2.5 w-full;
    min-width: 0;
}

.menu-title-clip {
    display: block;
    flex: 1;
    min-width: 0;
    overflow: hidden;
    white-space: nowrap;
}

.menu-title-marquee {
    display: inline-flex;
    max-width: 100%;
    min-width: 0;
    vertical-align: top;
}

.menu-title-label {
    display: inline-block;
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.menu-title-ghost {
    display: none;
    padding-left: 32px;
    white-space: nowrap;
}

/* 收合狀態下的置中樣式 */
:deep(.ant-menu-inline-collapsed) .menu-item-content {
    @apply justify-center items-center gap-0 p-0 w-full flex;
    height: 100%;
}

:deep(.ant-menu-inline-collapsed) .menu-item-content .anticon {
    @apply m-0 text-lg flex items-center justify-center;
    /* 移除 transform，讓 icon 自然置中 */
}
</style>
